The details of the uploaded candidate that was updated.
